const BADGE = {
  generated: {
    label: "Generated",
    title: "Generated from the discovered tools — open Edit to review, apply, or discard.",
    className: "bg-fill-indigo-50 text-ink-hex-4338ca dark:bg-fill-hex-312e81/30 dark:text-ink-hex-a5b4fc",
  },
  modified: {
    label: "Modified",
    title: "Changed since this agent was loaded — saved with the agent.",
    className: "bg-fill-hex-fffbeb text-ink-amber-700 dark:bg-fill-hex-78350f/30 dark:text-ink-amber-300",
  },
};

/** `status` is null while the draft still matches its stored content. */
const DraftStatusBadge = ({ status }) => {
  const badge = BADGE[status];
  if (!badge) return null;

  return (
    <span
      title={badge.title}
      className={`ml-2 rounded px-1.5 py-0.5 text-[10px] font-medium ${badge.className}`}
    >
      {badge.label}
    </span>
  );
};

export default DraftStatusBadge;
